var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOutline = function SvgEyeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7a5.007 5.007 0 0 1 5 5 5.002 5.002 0 0 1-5.976 4.904A5 5 0 0 1 12 7m1.148 2.229a3.001 3.001 0 1 0-2.297 5.545 3.001 3.001 0 0 0 2.297-5.545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.654c6.192 0 9.72 4.238 11.27 6.764a4.91 4.91 0 0 1 0 5.162c-1.55 2.526-5.078 6.765-11.27 6.765S2.28 17.106.729 14.58a4.91 4.91 0 0 1 0-5.162C2.279 6.892 5.809 2.654 12 2.654m0 2c-5.219 0-8.234 3.645-9.566 5.81a2.92 2.92 0 0 0 0 3.07c1.332 2.165 4.347 5.81 9.566 5.81s8.234-3.645 9.565-5.81a2.92 2.92 0 0 0 0-3.07c-1.332-2.17-4.347-5.81-9.565-5.81"
  }))));
};
export default SvgEyeOutline;